<template>
	<div class="content__column content__column--small">
		<h1 class="content__title">Información del Carrito</h1>
		<div class="information" v-if="cart">
			<p v-if="cart.user_id" class="information__text"><strong class="information__text--strong">Id de usuario: </strong>{{ cart.user_id }}</p>
			<p v-if="cart.date_created" class="information__text"><strong class="information__text--strong">Fecha de creación: </strong>{{ cart.date_created | longDate }}</p>
			<p v-if="cart.date_updated" class="information__text"><strong class="information__text--strong">Fecha de actualización: </strong>{{ cart.date_updated | longDate }}</p>
			<p v-if="cart.guest_user" class="information__text"><strong class="information__text--strong">Tipo de usuario: </strong>{{ cart.guest_user == 1 ? 'Usuario no registrado' : 'Cliente Registrado' }}</p>
		</div>
		<div class="results" v-if="cart.items">
			<h2 class="content__subtitle">Productos</h2>
			<div class="results__element" v-for="(product, index) in cart.items" :key="index">
				<div class="results__info">
					<h2 class="results__title">Id de Producto: {{ product.item_id }}</h2>
					<p class="results__text">Título: {{ product.title_es }}</p>
					<p class="results__text">Color: {{ product.color_es }}</p>
					<p class="results__text">Tamaño: {{ product.size_es }}</p>
					<p class="results__text">Cantidad: {{ product.quantity }}</p>
					<p class="results__text">Disponible: {{ product.available }}</p>
					<p class="results__text">Precio: {{ product.price | price }}</p>
				</div>
				<div class="results__actions">
					<router-link :to="{ name: 'productView' }" @click.prevent="$parent.$emit('view', product.user_id)" class="btn btn__icon btn__icon--regular results__btn results__btn--view">
						Ir al producto
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		cart: {
			type: Object
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/shopping_carts/view.vue